module.exports = __webpack_public_path__ + "94548e33e2b269640beeb64b1c3dfa0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-odaijini.png
// module id = 2069
// module chunks = 4